import { createSelector } from 'reselect';

export const getClientCode = (state) => state.init.clientCode;
export const getClient = (state) => state.init.client;

const getClientTheme = createSelector(
  [getClient],
  (client) => client.data.dashboard.theme
);

export const getClientLogo = createSelector(
  [getClientTheme],
  (theme) => theme.logo
);

export const getClientColor = createSelector(
  [getClientTheme],
  (theme) => theme.color
);

export const getClientLabel = createSelector(
  [getClientTheme],
  (theme) => theme.label
);

export const getClientResetPasswordLink = createSelector(
  [getClient],
  (client) => client.reset_password_link
);

export const getClientFavicon = createSelector(
  [getClientTheme],
  (theme) => theme.favicon
);

export const getClientShawLabel = createSelector(
  [getClient],
  (client) => client.data.dashboard.shaw_label
);

export const getProducts = (state) => state.init.client.products;



// WEBPACK FOOTER //
// ./src/actions/ui/init/initSelectors.js